import {
  GET_LABREQUESTTEST_FAIL,
  GET_LABREQUESTTEST_SUCCESS,
  GET_LABREQUESTTESTS_FAIL,
  GET_LABREQUESTTESTS_SUCCESS,
  ADD_LABREQUESTTEST_SUCCESS,
  ADD_LABREQUESTTEST_FAIL,
  UPDATE_LABREQUESTTEST_SUCCESS,
  UPDATE_LABREQUESTTEST_FAIL,
  DELETE_LABREQUESTTEST_SUCCESS,
  DELETE_LABREQUESTTEST_FAIL,  
  SET_STATE_LABREQUESTTEST
} from "./actionTypes";

const INIT_STATE = {
  labRequestTests: [],
  labRequestTest: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestTests = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTTESTS_SUCCESS:
      return {
        ...state,
        labRequestTests: action.payload.labRequestTests,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTTEST:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTTESTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTTEST_SUCCESS:
      return {
        ...state,
        labRequestTests: [...state.labRequestTests, action.payload],
      };

    case ADD_LABREQUESTTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTTEST_SUCCESS:
      return {
        ...state,
        labRequestTests: state.labRequestTests.map(labRequestTest =>
          labRequestTest.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestTest }
            : labRequestTest
        ),
      };

    case UPDATE_LABREQUESTTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTTEST_SUCCESS:
      return {
        ...state,
        labRequestTests: state.labRequestTests.filter(
          labRequestTest => labRequestTest.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTTEST_SUCCESS:
      return {
        ...state,
        labRequestTest: action.payload,
      };

    case GET_LABREQUESTTEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestTests;
